import { FormikProps } from "formik";

import { Button, ButtonsWrapper } from "components/elements";

import { TEXTS } from "../constants";
import { TiVoPublicationsForm } from "../types";

export function PublicationsFormButtons({
  dirty,
  isSubmitting,
  resetForm,
  submitForm,
}: FormikProps<TiVoPublicationsForm>) {
  return (
    <ButtonsWrapper>
      <Button
        disabled={!dirty || isSubmitting}
        dataTestId="reset-publications-button"
        onClick={resetForm}
      >
        {TEXTS.FORM_RESET_BUTTON}
      </Button>
      <Button
        disabled={!dirty || isSubmitting}
        processing={isSubmitting}
        type="green"
        dataTestId="update-publications-button"
        onClick={submitForm}
      >
        {TEXTS.FORM_SUBMIT_BUTTON}
      </Button>
    </ButtonsWrapper>
  );
}
